export const AMPLITUDE_API_KEY = process.env.GATSBY_AMPLITUDE_API_KEY;
